import React from 'react'
import reactStamp from 'react-stamp'
import {Tabs, Tab} from 'material-ui/Tabs';
import Schedule from 'material-ui/svg-icons/action/schedule';
import DeviceIcon from 'material-ui/svg-icons/hardware/watch';
import HealthIcon from 'material-ui/svg-icons/action/assignment';
import MapsPersonPin from 'material-ui/svg-icons/social/person-outline';
import './tabs-panel.css'

export default reactStamp(React).compose({

    render() {
        let initialSelectedIndex;
        switch (this.props.active) {
            case 'home':
                initialSelectedIndex = 0;
                break;
            case 'health':
                initialSelectedIndex = 1;
                break;
            case 'appointments':
                initialSelectedIndex = 2;
                break;
            case 'devices':
                initialSelectedIndex = 3;
                break;
            default:
                break;
        }
        return (
            <div className="tabs-panel-container">
                <Tabs
                    initialSelectedIndex={initialSelectedIndex}
                >
                    <Tab
                        icon={<MapsPersonPin />}
                        label="HOME"
                        onActive={this.props.activateHome}
                    />
                    <Tab
                        icon={<HealthIcon />}
                        label="HEALTH"
                        onActive={this.props.activateHealth}
                    />
                    <Tab
                        icon={<Schedule />}
                        label="BOOK"
                        onActive={this.props.activateAppointments}
                    />
                    <Tab
                        icon={<DeviceIcon />}
                        label="DEVICES"
                        onActive={this.props.activateDevices}
                    />
                </Tabs>
            </div>
        )
    },

});


/** WEBPACK FOOTER **
 ** ./src/app/components/TabsPanel/index.js
 **/